const mm = {
  // ==================== CATALOG VIEW ====================
  'catalogs.title': 'Verfügbare Kataloge',
  'catalogs.subtitle': 'Wählen Sie einen Katalog aus oder erstellen Sie eine BANF direkt',
  'catalogs.favorites': 'Favoriten',
  'catalogs.favoritesSupplier': 'Benutzerspezifisch',
  'catalogs.favoritesDesc': 'Ihre persönlichen favorisierten Artikel und häufig bestellte Produkte',
  'catalogs.search': 'Kataloge durchsuchen...',
  'catalogs.empty': 'Keine Kataloge verfügbar',
  'catalogs.emptyDesc': 'Es sind keine Kataloge konfiguriert.',
  'catalogs.ociShop': 'OCI-Shop',
  'catalogs.internalShop': 'Interner Katalog',
  'catalogs.products': 'Produkte',
  'catalogs.items': 'Artikel',
  'catalogs.mobileWarning': 'OCI-Kataloge funktionieren am besten auf einem Desktop-Computer',
  'catalogs.filterAll': 'Alle',
  'catalogs.filterOci': 'OCI-Shops',
  'catalogs.filterInternal': 'Interne Shops',
  'catalogs.filterFavorites': 'Favoriten',
  'catalogs.filterKpis': 'Kennzahlen',
  'kpi.title': 'Beschaffungs-Kennzahlen',
  'kpi.valueYtd': 'Bestellwert (Jahr)',
  'kpi.valueMtd': 'Bestellwert (Monat)',
  'kpi.count': 'BANF-Anfragen',
  'kpi.avg': 'Ø BANF-Wert',
  'kpi.thisYear': 'laufendes Jahr',
  'kpi.thisMonth': 'aktueller Monat',
  'kpi.perRequest': 'pro Anfrage',
  'kpi.statusPending': 'offen',
  'kpi.statusApproved': 'genehmigt',
  'kpi.statusRejected': 'abgelehnt',
  'kpi.trend12m': 'Bestellwert — letzte 12 Monate',
  'kpi.topGroups': 'Top-Warengruppen',
  'kpi.topCostCenters': 'Top-Kostenstellen',
  'kpi.groupOther': 'Sonstige',
  'kpi.noData': 'Keine Daten',
  'kpi.empty': 'Noch keine BANF-Daten für Kennzahlen.',
  'kpi.filterAll': 'Alle',
  'kpi.filterYear': 'Jahr',
  'kpi.filterStatus': 'Status',
  'kpi.filterEkgrp': 'Einkäufergruppe',
  'kpi.filterMatkl': 'Warengruppe',
  'kpi.filterKostl': 'Kostenstelle',
  'kpi.filterAnforderer': 'Anforderer',
  'kpi.filterAbteilung': 'Abteilung',
  'kpi.filterWerk': 'Werk',
  'kpi.filterMaterial': 'Material',
  'kpi.filterLieferant': 'Lieferant',
  'kpi.filterBelegart': 'Belegart',
  'kpi.filterKontierung': 'Kontierungstyp',
  'kpi.reset': 'Zurücksetzen',
  'kpi.moreFilters': 'Mehr Filter',
  'kpi.export': 'Excel-Export',
  'kpi.exporting': 'Exportiere …',
  'kpi.selectAll': 'Alle auswählen',
  'kpi.clearAll': 'Alle abwählen',
  'kpi.search': 'Suchen …',
  'catalogs.blankBanfTitle': 'Leere BANF erstellen',
  'catalogs.blankBanfDesc': 'Bestellanforderung ohne Katalog-Artikel manuell anlegen',
  'catalogs.blankBanfBtn': 'BANF erstellen',
  'catalogs.goToCart': 'Zum Warenkorb',
  'catalogs.inCart': 'Artikel',
  'catalogs.recentDrafts': 'Letzte Entwürfe',
  'catalogs.noDrafts': 'Keine Entwürfe vorhanden',
  'catalogs.positionsCount': '{count} Positionen',
  'catalogs.buyingTip': 'Einkaufs-Tipp',
  'catalogs.buyingTipText': 'Vergleichen Sie Preise über mehrere Kataloge hinweg. Artikel mit Rahmenverträgen oder Infosätzen bieten oft bessere Konditionen als Einzelkäufe.',
  'catalogs.statusDrafts': 'Offene Entwürfe',
  'catalogs.statusInCart': 'Im Warenkorb',
  'catalogs.statusApproval': 'In Genehmigung',
  'catalogs.myDrafts': 'Meine Entwürfe',
  'catalogs.subtotal': 'Zwischensumme',
  'catalogs.vat': 'MwSt. (19%)',
  'catalogs.grandTotal': 'Gesamtbetrag',
  'catalogs.estimatedTotal': 'Schätzpreis (gesamt)',
  'catalogs.estimatedHint': 'Endpreis inkl. Steuer wird in der Bestellung ermittelt.',
  'catalogs.help': 'Hilfe & Support',
  'catalogs.helpDesc': 'Probleme beim Bestellen oder im Katalog-Punchout?',
  'catalogs.contactSupport': 'Support kontaktieren',
  'catalogs.openShop': 'Shop öffnen',
  'catalogs.viewProducts': 'Produkte ansehen',
  'catalogs.openFavorites': 'Favoriten öffnen',
  'catalogs.ociModeActive': 'OCI-Katalog-Modus aktiv',
  'catalogs.ociModeDesc': 'Direkte SAP-Integration — Artikel werden automatisch übertragen',
  'catalogs.mobileWarningDetail': 'Viele OCI-Shops blockieren mobile Einbettung (X-Frame-Options). Bei weißem Bildschirm bitte im Browser öffnen.',
  'catalogs.footerPersonal': 'Persönliche Auswahl',
  'catalogs.footerBrowser': 'Integrierter Browser',
  'catalogs.footerNewWindow': 'Neues Fenster',
  'catalogs.footerInternal': 'Interne Produkte',
  'catalogs.resetSearch': 'Suche zurücksetzen',

  // ==================== PRODUCT VIEW ====================
  'products.backToCatalogs': 'Zurück zu Katalogen',
  'products.search': 'Produkte suchen...',
  'products.loading': 'Produkte werden geladen...',
  'products.empty': 'Keine Produkte gefunden',
  'products.emptyDesc': 'Versuchen Sie einen anderen Suchbegriff.',
  'products.addToCart': 'Zum Warenkorb hinzufügen',
  'products.inCart': 'Im Warenkorb',
  'products.filter': 'Filter',
  'products.filterReset': 'Zurücksetzen',
  'products.filterMaterialType': 'Materialart',
  'products.filterStatus': 'Status',
  'products.status.active': 'Aktiv',
  'products.status.blocked': 'Gesperrt',
  'products.status.discontinued': 'Auslauf',
  'products.filterCategory': 'Warengruppe',
  'products.filterManufacturer': 'Hersteller',
  'products.filterAttributes': 'Klassifizierung',
  'products.filterOf': 'von',
  'products.productsWord': 'Produkten',
  'products.filterForTerm': 'für',
  // Sortierung + Pagination (F10)
  'products.sortLabel': 'Sortieren',
  'products.sortRelevance': 'Relevanz',
  'products.sortNameAsc': 'Name A–Z',
  'products.sortNameDesc': 'Name Z–A',
  'products.sortPriceAsc': 'Preis aufsteigend',
  'products.sortPriceDesc': 'Preis absteigend',
  'products.sortNewest': 'Neueste zuerst',
  'products.loadMore': 'Mehr laden',
  'products.showingCount': '{shown} von {total} angezeigt',
  'products.priceLabel': 'Preis (EUR)',
  'products.priceFrom': 'von',
  'products.priceTo': 'bis',
  'products.addFilter': '+ Filter',
  'products.filterFields': 'Filter-Felder',
  'products.filterGroupMasterdata': 'Stammdaten',
  'products.filterActiveCount': '{count} aktiv',
  'products.filterSavePrefs': 'Feldauswahl gespeichert',
  'products.supplierBy': 'von {supplier}',
  'products.aiTipTitle': 'KI-Tipp:',
  'products.aiTipText': 'Basierend auf Ihrem Bedarf empfehlen wir die Aufstockung von Verbrauchsmaterial für das nächste Quartal.',
  'products.imageAlt': 'Produktbild',
  'products.unnamedProduct': 'Unbenanntes Produkt',
  'products.noDescriptionAvailable': 'Keine Beschreibung verfügbar',
  'products.inStock': '{n} {unit} auf Lager',
  'products.resetSearch': 'Suche zurücksetzen',
  'products.sapInsights': 'SAP-Insights',
  'products.totalStock': 'Lagerbestand gesamt',
  'products.avgDeliveryTime': 'Ø Lieferzeit',
  'products.activeContracts': 'Aktive Rahmenverträge',

  // ==================== PRODUCT DETAIL ====================
  'productDetail.back': 'Zurück',
  'productDetail.notFound': 'Produkt nicht gefunden.',
  'productDetail.profileTechnician': 'Techniker',
  'productDetail.profileBuyer': 'Einkäufer',
  'productDetail.editButton': 'Bearbeiten',
  'productDetail.editTitle': 'Katalogprodukt bearbeiten',
  'productDetail.editName': 'Bezeichnung',
  'productDetail.editDescription': 'Beschreibung',
  'productDetail.editPrice': 'Preis (EUR)',
  'productDetail.editSave': 'Speichern',
  'productDetail.editSaving': 'Speichern…',
  'productDetail.editCancel': 'Abbrechen',
  'productDetail.editNameRequired': 'Bezeichnung darf nicht leer sein.',
  'productDetail.editPriceInvalid': 'Preis muss eine Zahl ≥ 0 sein.',
  'productDetail.editError': 'Speichern fehlgeschlagen.',
  'productDetail.sku': 'Artikelnr.',
  'productDetail.sapMaterialNo': 'SAP-Materialnr.',
  'productDetail.manufacturer': 'Hersteller',
  'productDetail.manufacturerPartNo': 'Herstellerteilenr.',
  'productDetail.priceNet': 'Preis (netto)',
  'productDetail.addToCart': 'In den Warenkorb',
  'productDetail.technicalData': 'Technische Daten',
  'productDetail.technicalEmpty': 'Noch keine technischen Merkmale — kommen später aus der SAP-Klassifizierung.',
  'productDetail.demoFromSap': 'Demo – später aus SAP',
  'productDetail.procurement': 'Beschaffung',
  'productDetail.orderUnit': 'Bestellmengeneinheit',
  'productDetail.preferredVendor': 'Wunschlieferant',
  'productDetail.fixedVendor': 'Fester Lieferant',
  'productDetail.purchasingOrg': 'Einkaufsorganisation',
  'productDetail.purchasingGroup': 'Einkäufergruppe',
  'productDetail.leadTime': 'Plan-Lieferzeit',
  'productDetail.minOrderQuantity': 'Mindestbestellmenge',
  'productDetail.infoRecord': 'Infosatz',
  'productDetail.framework': 'Rahmenvertrag',
  'productDetail.validTo': 'gültig bis',
  'productDetail.priceScales': 'Mengenstaffeln',
  'productDetail.fromQty': 'ab',
  'productDetail.availability': 'Verfügbarkeit',
  'productDetail.availabilityEmpty': 'Kein Bestand hinterlegt.',
  'productDetail.plant': 'Werk',
  'productDetail.storageLocation': 'Lagerort',
  'productDetail.documents': 'Dokumente',
  'productDetail.download': 'Download',
  'productDetail.compliance': 'Compliance & Zertifikate',
  'productDetail.aiAdvisor': 'KI-Einkaufsberater',
  'productDetail.aiAdvisorHint': 'Ähnliche Artikel mit Rahmenvertrag könnten günstiger sein. (Vorschau – noch ohne echte Logik.)',
  'productDetail.priceSource.contract': 'Kontraktpreis',
  'productDetail.priceSource.inforecord_plant': 'Infosatz (werksspez.)',
  'productDetail.priceSource.inforecord_general': 'Infosatz (allgemein)',
  'productDetail.priceSource.estimate': 'Schätzpreis',
  'productDetail.priceSource.internal': 'Interner Shop-Preis',
  'productDetail.stockOwn': 'Eigener Bestand',
  'productDetail.stockVendorConsignment': 'Konsignation (Lieferant)',
  'productDetail.stockAtVendor': 'Bestand beim Lieferanten',
  'productDetail.stockVendor': 'Lief.',
  'productDetail.sources': 'Bezugsquellen',
  'productDetail.primarySource': 'Primär',
  'productDetail.vendorMaterialNo': 'Lief.-Materialnr.',
  'productDetail.deliveryTime': 'Lieferzeit (Tage)',
  'productDetail.minOrderQty': 'Mindestbestellmenge',
  'productDetail.incoterms': 'Incoterms',
  'productDetail.priceScalesFull': 'Staffelpreise',
  'productDetail.scaleFrom': 'ab {qty} {unit}',
  'productDetail.orderHistory': 'Bestellhistorie',
  'productDetail.orderHistoryMore': '{count} weitere Einträge',
  'productDetail.noContract': 'Kein Rahmenvertrag hinterlegt',
  'productDetail.orderDate': 'Datum',
  'productDetail.orderQty': 'Menge',
  'productDetail.orderPrice': 'Preis',
  'productDetail.orderValue': 'Wert',
  'productDetail.orderVendor': 'Lieferant',

  // ==================== CART VIEW ====================
  'cart.title': 'Warenkorb',
  'cart.items': 'Artikel',
  'cart.back': 'Zurück',
  'cart.selectAll': 'Alle auswählen',
  'cart.deselectAll': 'Auswahl aufheben',
  'cart.deleteCount': '{count} löschen',
  'cart.selectedOf': '{selected} von {total} ausgewählt',
  'cart.empty': 'Ihr Warenkorb ist leer',
  'cart.emptyDesc': 'Fügen Sie Artikel aus den verfügbaren Katalogen hinzu, um mit der Bestellung zu beginnen.',
  'cart.emptyBrowse': 'Kataloge durchsuchen',
  'cart.removedItems': '{count} Artikel aus dem Warenkorb entfernt.',
  'cart.addedToFavorites': 'Artikel wurde zu Ihren Favoriten hinzugefügt',
  'cart.loginForFavorites': 'Sie müssen angemeldet sein, um Favoriten zu speichern',
  'cart.errorSavingFavorite': 'Fehler beim Speichern des Favoriten',
  'cart.headerTotal': 'Gesamt',
  'cart.incomplete': 'Unvollständig',
  'cart.editItem': 'Artikel bearbeiten',
  'cart.addToFavorites': 'Zu Favoriten hinzufügen',
  'cart.removeItem': 'Artikel entfernen',
  'cart.kontpiCostCenter': 'Kostenstelle',
  'cart.kontpiOrder': 'Auftrag',
  'cart.detailsMaterial': 'Material & Artikel',
  'cart.detailsManufacturer': 'Hersteller',
  'cart.detailsAccounting': 'Kontierung',
  'cart.detailsPurchasing': 'Beschaffung',
  'cart.detailsNotes': 'Anmerkungen',
  'cart.materialNumber': 'Materialnummer',
  'cart.productGroup': 'Warengruppe',
  'cart.supplier': 'Lieferant',
  'cart.supplierArtNo': 'Lieferanten-Art.-Nr.',
  'cart.manufacturer': 'Hersteller',
  'cart.manufacturerPartNo': 'Hersteller-Teile-Nr.',
  'cart.costCenter': 'Kostenstelle',
  'cart.glAccount': 'Sachkonto',
  'cart.orderNumber': 'Auftragsnummer',
  'cart.wbsElement': 'PSP-Element',
  'cart.assetNumber': 'Anlagennummer',
  'cart.networkNumber': 'Netzwerknummer',
  'cart.purchasingOrg': 'Einkaufsorganisation',
  'cart.purchasingGroup': 'Einkäufergruppe',
  'cart.plant': 'Werk',
  'cart.storageLocation': 'Lagerort',
  'cart.requester': 'Anforderer',
  'cart.longText': 'Langtext',
  'cart.changeQuantity': 'Menge ändern:',
  'cart.quantityLabel': 'Menge:',
  'cart.totalLabel': 'Gesamt',
  'cart.removeLabel': 'Entfernen',
  'cart.summary': 'Zusammenfassung',
  'cart.yourOrder': 'Ihre Bestellung',
  'cart.articleCount': '{count} Artikel im Warenkorb',
  'cart.selectedItems': 'Ausgewählt: {count} Artikel',
  'cart.selectedTotal': 'Ausgewählt',
  'cart.totalAmount': 'Gesamtbetrag',
  'cart.ociTransfer': 'OCI-Übertragung',
  'cart.ociTransferDesc': 'Warenkorb wird an das aufrufende System übertragen',
  'cart.ociTransferBtn': 'An SAP übertragen',
  'cart.ociTransferSelectedBtn': 'Ausgewählte an SAP übertragen',
  'cart.createBanf': 'BANF erstellen',
  'cart.createBanfDesc': 'Bestellanforderung aus dem Warenkorb erstellen',
  'cart.createBanfBtn': 'BANF erstellen',
  'cart.createBanfSelectedBtn': 'BANF aus Auswahl',
  'cart.estimatedTotal': 'Schätzpreis (gesamt)',
  'cart.estimatedHint': 'Endpreis inkl. Steuer wird in der Bestellung ermittelt.',
  'cart.applyKontierungAll': 'Kontierung für alle Positionen übernehmen',
  'cart.kontForAll': 'Kontierung für alle',
  'cart.kontForSelected': 'Kontierung für Auswahl ({count})',
  'cart.kontierungAppliedAll': 'Kontierung auf alle Positionen übernommen.',
  'cart.kontierungApplyError': 'Kontierung konnte nicht übernommen werden.',
  'cart.kontModalTitle': 'Kontierung für alle Positionen übernehmen',
  'cart.kontModalDesc': 'Diese Kontierung wird auf alle {n} Positionen im Warenkorb angewendet. Du kannst sie vorher anpassen. Leere Felder werden nicht überschrieben.',
  'cart.kontType': 'Kontierungstyp',
  'cart.kontCostCenter': 'Kostenstelle',
  'cart.kontGlAccount': 'Sachkonto',
  'cart.kontPlant': 'Werk',
  'cart.kontApply': 'Auf alle übernehmen',
  'cart.kontCancel': 'Abbrechen',
  'cart.syncDemo': 'zuletzt mit SAP synchronisiert',
  'cart.approvalPath': 'Genehmigungsweg (vorhergesagt)',
  'cart.aiCheckTitle': 'KI-Prüfung',
  'cart.aiCheckDesc': 'Positionen wurden automatisch auf Plausibilität geprüft. Keine Auffälligkeiten gefunden.',
  'cart.approvalDeptHead': 'Abteilungsleiter',
  'cart.approvalFinance': 'Finanzprüfung ausstehend',
  'cart.prefixMat': 'Mat.',
  'cart.prefixVendorNo': 'Lief.-Nr.',
  'cart.fieldDeliveryDate': 'Lieferdat.',
  'cart.fieldCostCenter': 'KST',
  'cart.fieldOrder': 'Auftrag',
  'cart.fieldGlAccount': 'Sachkto.',
  'cart.fieldPlant': 'Werk',
  'cart.fieldRequester': 'Anforderer',
  'cart.kontpiDefault': 'Standard',
  'cart.collapseTitle': 'Einklappen',
  'cart.detailsTitle': 'Details',
  'cart.missingCostCenter': 'Kostenstelle',
  'cart.missingSachkonto': 'Sachkonto',
  'cart.missingOrder': 'Auftrag',
  'cart.missingDeliveryDate': 'Lieferdatum',
  'cart.missingPlant': 'Werk',
  'cart.noFurtherDetails': 'Keine weiteren Details vorhanden',
  'cart.ociModeActive': 'OCI-Modus aktiv',
  'cart.ociNoApproval': 'Ohne Genehmigungsverfahren',
  'cart.ociHookMissing': 'Hook-URL fehlt - Session prüfen',
  'cart.ociHookMissingTitle': 'Hook-URL nicht verfügbar - Session möglicherweise abgelaufen',
  'cart.ociUser': 'Benutzer:',
  'cart.ociSystem': 'System:',
  'cart.ociUserFallback': 'OCI-Benutzer',
  'cart.kontCostCenterPlaceholder': 'z. B. 4711',
  'cart.kontGlAccountPlaceholder': 'z. B. 400000',
  'cart.kontPlantPlaceholder': 'z. B. 1000',

  // ==================== FAVORITES VIEW ====================
  'favorites.title': 'Meine Favoriten',
  'favorites.count': '{count} gespeicherte Artikel',
  'favorites.empty': 'Noch keine Favoriten',
  'favorites.emptyDesc': 'Fügen Sie Artikel aus den Katalogen zu Ihren Favoriten hinzu.',
  'favorites.addToCart': 'In den Warenkorb',
  'favorites.delete': 'Favorit löschen',
  'favorites.deleteConfirm': 'Möchten Sie diesen Favoriten wirklich löschen?',
  'favorites.deleted': 'Favorit wurde gelöscht.',
  'favorites.deleteError': 'Fehler beim Löschen des Favoriten',
  'favorites.search': 'Favoriten durchsuchen...',
  'favorites.loadError': 'Fehler beim Laden der Favoriten',
  'favorites.refresh': 'Aktualisieren',
  'favorites.editFavorite': 'Favorit bearbeiten',
  'favorites.filterAll': 'Alle',
  'favorites.noMatch': 'Keine Favoriten passen zu den Filtern.',
  'favorites.detMore': 'Mehr Details',
  'favorites.detLess': 'Weniger',
  'favorites.detDescription': 'Beschreibung',
  'favorites.detProductGroup': 'Warengruppe',
  'favorites.detQuantity': 'Menge',
  'favorites.detDeliveryDate': 'Lieferdatum',
  'favorites.detStorage': 'Lagerort',
  'favorites.detManufacturerPartNo': 'Herstellernr.',
  'favorites.detOrder': 'Auftrag',
  'favorites.detRequester': 'Anforderer',
  'favorites.detPurchasingOrg': 'Einkäuferorg.',
  'favorites.detPurchasingGroup': 'Einkäufergruppe',
  'favorites.typeKostenstelle': 'Kostenstelle',
  'favorites.typeAuftrag': 'Auftrag',
  'favorites.typeMaterial': 'Material',
  'favorites.typeDienstleistung': 'Dienstleistung',
  'favorites.typeDefault': 'Standard',
  'favorites.sortRecent': 'Neueste zuerst',
  'favorites.sortNameAZ': 'Name (A–Z)',
  'favorites.sortPriceDesc': 'Preis (absteigend)',
  'favorites.sortPriceAsc': 'Preis (aufsteigend)',
  'favorites.chipMat': 'Mat.',
  'favorites.chipVendorNo': 'Lief.-Nr.',
  'favorites.chipKst': 'KST',
  'favorites.chipGlAccount': 'Sachkto.',
  'favorites.chipPlant': 'Werk',
  'favorites.chipStorage': 'Lager',
  'favorites.chipProductGroup': 'WGr.',
  'favorites.chipQuantity': 'Menge',
  'favorites.chipRequester': 'Anf.',

  // ==================== SAVED CARTS ====================
  'savedCarts.modal.title': 'Warenkorb speichern',
  'savedCarts.modal.subtitle': '{count} Artikel · {total} EUR',
  'savedCarts.modal.nameLabel': 'Name',
  'savedCarts.modal.namePlaceholder': 'z. B. Büromaterial Q3, Schrauben Sortiment …',
  'savedCarts.modal.nameRequired': 'Bitte einen Namen eingeben.',
  'savedCarts.modal.tagsLabel': 'Tags',
  'savedCarts.modal.tagsPlaceholder': 'z. B. Reinigung, Wartung, Büro',
  'savedCarts.modal.tagsHint': 'Mehrere Tags durch Komma trennen',
  'savedCarts.modal.noteLabel': 'Notiz',
  'savedCarts.modal.notePlaceholder': 'Optionale Anmerkung …',
  'savedCarts.modal.templateLabel': 'Als Vorlage speichern',
  'savedCarts.modal.templateHint': 'Vorlagen können mit einem Klick direkt geladen werden.',
  'savedCarts.modal.saveBtn': 'Speichern',
  'savedCarts.modal.saving': 'Speichern…',
  'savedCarts.saveCartBtn': 'Warenkorb speichern',
  'savedCarts.saveSelectedBtn': 'Auswahl speichern ({count})',
  'savedCarts.panel.title': 'Gespeicherte Warenkörbe',
  'savedCarts.panel.searchPlaceholder': 'Name, Tags oder Notiz suchen…',
  'savedCarts.panel.empty': 'Keine gespeicherten Warenkörbe',
  'savedCarts.panel.emptyFiltered': 'Keine Ergebnisse',
  'savedCarts.panel.clearFilter': 'Filter zurücksetzen',
  'savedCarts.panel.templateBadge': 'Vorlage',
  'savedCarts.panel.priceCheckBadge': 'Preis prüfen',
  'savedCarts.panel.itemCount': '{count} Positionen',
  'savedCarts.panel.loadReplace': 'Laden (ersetzen)',
  'savedCarts.panel.loadAppend': 'Anhängen',
  'savedCarts.panel.renameBtn': 'Umbenennen',
  'savedCarts.panel.deleteConfirm': '„{name}" wirklich löschen?',
  'savedCarts.loadSuccess': 'Warenkorb geladen.',
  'savedCarts.loadError': 'Fehler beim Laden des gespeicherten Warenkorbs.',
  'savedCarts.saveSuccess': 'Warenkorb gespeichert.',
  'savedCarts.saveError': 'Fehler beim Speichern des Warenkorbs.',
  'savedCarts.deleteSuccess': 'Gespeicherter Warenkorb gelöscht.',
  'savedCarts.deleteError': 'Fehler beim Löschen.',
  'savedCarts.renameSuccess': 'Gespeicherter Warenkorb aktualisiert.',
  'savedCarts.renameError': 'Fehler beim Aktualisieren.',

  // ==================== MISSING FIELDS MODAL ====================
  'missingFields.title': 'Fehlende Pflichtfelder',
  'missingFields.subtitle': 'Bitte ergänzen Sie die fehlenden Angaben',
  'missingFields.titlePrepare': 'Position ergänzen',
  'missingFields.subtitlePrepare': 'Pflichtfelder (*) ausfüllen, optionale Felder anpassen',
  'missingFields.article': 'Artikel:',
  'missingFields.unnamedFallback': 'Unbenannt',
  'missingFields.requiredHint': 'Mit * markierte Felder sind Pflichtfelder und müssen ausgefüllt werden.',
  'missingFields.optionalHint': 'Optionale Felder — vorbefüllt aus Produktdaten, jederzeit änderbar',
  'missingFields.optional': 'optional',
  'missingFields.costCenter': 'Kostenstelle *',
  'missingFields.costCenterLabel': 'Kostenstelle',
  'missingFields.purchasingOrg': 'Einkaufsorganisation *',
  'missingFields.purchasingOrgLabel': 'Einkaufsorganisation',
  'missingFields.plant': 'Werk *',
  'missingFields.plantLabel': 'Werk',
  'missingFields.searchCostCenter': 'Suche nach Kostenstelle...',
  'missingFields.searchPurchasingOrg': 'Suche nach Einkaufsorganisation...',
  'missingFields.searchPlant': 'Suche nach Werk...',
  'missingFields.glAccount': 'Sachkonto',
  'missingFields.searchGlAccount': 'Suche nach Sachkonto...',
  'missingFields.auftrag': 'Auftrag',
  'missingFields.auftragPlaceholder': 'Auftragsnummer suchen, z. B. 1151551',
  'missingFields.purchasingGroup': 'Einkäufergruppe',
  'missingFields.searchPurchasingGroup': 'Suche nach Einkäufergruppe...',
  'missingFields.kontierungstyp': 'Kontierungstyp',
  'kontierung.typKostenstelle': 'Kostenstelle',
  'kontierung.typAuftrag': 'Auftrag',
  'kontierung.typMaterial': 'Material',
  'missingFields.preferredVendor': 'Wunschlieferant',
  'missingFields.preferredVendorPlaceholder': 'Name des gewünschten Lieferanten',
  'missingFields.addToCart': 'Zum Warenkorb hinzufügen',

  // ==================== OCI FRAME ====================
  'oci.title': 'OCI-Katalog',
  'oci.loading': 'OCI-Katalog wird geladen...',
  'oci.error': 'Fehler beim Laden des OCI-Katalogs',
  'oci.blocked': 'Pop-up blockiert',
  'oci.blockedDesc': 'Bitte erlauben Sie Pop-ups für diese Seite',
  'oci.mobileHint': 'Für die beste Erfahrung nutzen Sie einen Desktop-Browser',
  'oci.close': 'Katalog schließen',
  'oci.openExternal': 'In neuem Tab öffnen',
  'oci.transferring': 'Artikel werden übertragen...',
  'oci.reloadTitle': 'Neu laden',
  'oci.fullscreenTitle': 'Vollbild',
  'oci.showHeaderTitle': 'Header anzeigen',
  'oci.closeTitle': 'Schließen',
  'oci.frameTitle': 'OCI Katalog',

  // ==================== CREATE BANF VIEW ====================
  'banf.title': 'Neue BANF erstellen',
  'banf.draftSaveFailed': 'Entwurf konnte nicht gespeichert werden — Änderungen sind ggf. nicht gesichert.',
  'banf.draftDate': 'Entwurf vom {date}',
  'banf.back': 'Zurück',
  'banf.addItem': 'Position hinzufügen',
  'banf.removeAll': 'Alle entfernen',
  'banf.totalSum': 'Gesamtsumme',
  'banf.docType': 'Belegart',
  'banf.docTypeNB': 'NB - Bestellanforderung',
  'banf.docTypeFO': 'FO - Rahmenbestellanf.',
  'banf.docTypeRV': 'RV - Rahmenvertragsanf.',
  'banf.clearList': 'Liste leeren',
  'banf.updating': 'Wird aktualisiert...',
  'banf.adding': 'Wird hinzugefügt...',
  'banf.saveChanges': 'Änderungen speichern',
  'banf.ociTransfer': 'OCI-Artikel an Warenkorb übertragen',
  'banf.transferToCart': 'An Warenkorb übertragen',
  'banf.positionCopied': 'Position {position} wurde kopiert.',
  'banf.allItemsRemoved': 'Alle Positionen wurden entfernt.',
  'banf.ociItemsLoaded': '{count} OCI-Artikel erfolgreich geladen. Bitte prüfen Sie die Kontierungsangaben.',
  'banf.draftRestored': 'Gespeicherter Entwurf wurde wiederhergestellt.',
  'banf.addItemMin': 'Bitte fügen Sie mindestens einen Artikel hinzu.',
  'banf.cartSuccess': '{count} BANF-Artikel erfolgreich zum Warenkorb hinzugefügt!',
  'banf.cartPartialError': '{count} Artikel konnten nicht hinzugefügt werden.',
  'banf.cartError': 'Fehler beim Hinzufügen zum Warenkorb: ',
  'banf.updateNotFound': 'Kein Artikel zum Aktualisieren gefunden.',
  'banf.updateSuccess': 'Artikel erfolgreich aktualisiert!',
  'banf.updateAddedSuccess': 'Artikel aktualisiert und {count} neue Position(en) hinzugefügt!',
  'banf.updatePartialError': 'Artikel aktualisiert. {success} neue Position(en) hinzugefügt, {error} fehlgeschlagen.',
  'banf.updateAddError': 'Artikel aktualisiert. Neue Positionen konnten nicht hinzugefügt werden.',
  'banf.updateError': 'Fehler beim Aktualisieren des Artikels: ',
  'banf.sessionExpired': 'Sitzung abgelaufen: {error}',
  'banf.sessionExpiredDefault': 'Bitte melden Sie sich neu an',
  'banf.unknownError': 'Unbekannter Fehler',
  'banf.editSingleOnly': 'Im Bearbeitungsmodus kann nur ein Artikel bearbeitet werden.',
  'banf.favoriteUpdated': 'Favorit erfolgreich aktualisiert!',
  'banf.favoriteUpdateError': 'Fehler beim Aktualisieren des Favoriten: ',
  'banf.positionLabel': 'Position {n}',
  'banf.positionError': 'Position {n}: {fields}',
  'banf.longtextTemplate': 'BANF Position {pos} - Lieferdatum: {date}{group}{plant}{storage}',
  'banf.longtextGroup': ', Warengruppe: {value}',
  'banf.longtextPlant': ', Werk: {value}',
  'banf.longtextStorage': ', Lagerort: {value}',
  'banf.valFieldShortText': 'Kurztext',
  'banf.valFieldQuantity': 'Menge',
  'banf.valFieldDeliveryDate': 'Lieferdatum',
  'banf.valFieldProductGroup': 'Warengruppe',
  'banf.valFieldPrice': 'Geschätzter Preis',
  'banf.valFieldOrder': 'Auftrag',
  'banf.valFieldPsp': 'PSP-Element',
  'banf.valFieldCostCenter': 'Kostenstelle',
  'banf.valFieldGlAccount': 'Sachkonto',

  // ==================== BANF VALIDATION ====================
  'banf.val.shortTextRequired': 'Kurztext ist ein Pflichtfeld.',
  'banf.val.quantityRequired': 'Gültige Menge ist erforderlich.',
  'banf.val.deliveryDateRequired': 'Lieferdatum ist ein Pflichtfeld.',
  'banf.val.priceRequired': 'Geschätzter Preis ist ein Pflichtfeld und muss größer als 0 sein.',
  'banf.val.orderRequired': 'Auftrag ist ein Pflichtfeld bei Kontierungstyp "Auftrag".',
  'banf.val.costCenterOrderRequired': 'Kostenstelle ist ein Pflichtfeld bei Kontierungstyp "Auftrag".',
  'banf.val.costCenterRequired': 'Kostenstelle ist ein Pflichtfeld bei Kontierungstyp "Kostenstelle".',
  'banf.val.glAccountCostCenter': 'Sachkonto ist ein Pflichtfeld bei Kontierungstyp "Kostenstelle".',
  'banf.val.pspRequired': 'PSP-Element ist ein Pflichtfeld bei Kontierungstyp "PSP-Element".',
  'banf.val.glAccountRequired': 'Sachkonto ist ein Pflichtfeld.',
  'banf.val.missingFields': 'Fehlende Pflichtfelder in {parts}',
  'banf.val.missingFieldsMulti': 'Fehlende Pflichtfelder:\n{parts}',
  'banf.val.posShortText': 'Position {pos}: Kurztext ist ein Pflichtfeld.',
  'banf.val.posDeliveryDate': 'Position {pos}: Lieferdatum ist ein Pflichtfeld.',
  'banf.val.posPrice': 'Position {pos}: Geschätzter Preis ist ein Pflichtfeld.',

  // ==================== BANF ITEM CARD ====================
  'banf.item.copyPosition': 'Position kopieren',
  'banf.item.copy': 'Kopieren',
  'banf.item.removePosition': 'Position entfernen',
  'banf.item.remove': 'Entfernen',
  'banf.item.missingFields': 'Fehlende Pflichtfelder: ',
  'banf.item.article': 'Artikel:',
  'banf.item.quantity': 'Menge:',
  'banf.item.positionValue': 'Positionswert:',
  'banf.item.tabGeneral': 'Allgemein',
  'banf.item.tabLimits': 'Limits',
  'banf.item.tabServices': 'Leistungen',
  'banf.item.tabSource': 'Bezugsquelle',
  'banf.item.tabTexts': 'Texte',
  'banf.item.tabAttachments': 'Anhänge',
  'banf.item.naFallback': 'N/A',

  // ==================== BANF TYPE SELECTOR ====================
  'banf.type.costCenter': 'Kostenstelle',
  'banf.type.order': 'Auftrag',
  'banf.type.material': 'Material',
  'banf.type.psp': 'PSP-Element',
  'banf.general.psp': 'PSP-Element',
  'banf.general.pspPlaceholder': 'Projektschlüssel suchen (z.B. CUS250013)',

  // ==================== BANF GENERAL TAB ====================
  'banf.general.costCenterHiddenServicesAuftrag': 'Kostenstelle und Sachkonto werden über die Limits-Felder gesteuert, Auftrag und Kostenstelle sind aufgrund von Leistungen ausgeblendet',
  'banf.general.costCenterHiddenServices': 'Kostenstelle und Sachkonto werden über die Limits-Felder gesteuert, Kostenstelle ist aufgrund von Leistungen ausgeblendet',
  'banf.general.costCenterHiddenLimitsAuftrag': 'Auftrag und Kostenstelle sind aufgrund von Leistungspositionen ausgeblendet',
  'banf.general.costCenterHiddenLimits': 'Kostenstelle ist aufgrund von Leistungspositionen ausgeblendet',
  'banf.general.costCenterLimitsControlled': 'Kostenstelle und Sachkonto werden über die Limits-Felder gesteuert',
  'banf.general.kontierung': 'Kontierung (Kostenstelle) *',
  'banf.general.searchCostCenter': 'Suche nach Kostenstelle...',
  'banf.general.order': 'Auftrag *',
  'banf.general.orderPlaceholder': 'Auftragsnummer suchen, z.B. 1151551',
  'banf.general.costCenter': 'Kostenstelle *',
  'banf.general.glAccount': 'Sachkonto *',
  'banf.general.glAccountPlaceholder': 'z.B. 4100000',
  'banf.general.glAccountHint': 'Sachkonto (6-8 stellige Nummer)',
  'banf.general.material': 'Material',
  'banf.general.materialPlaceholder': 'Material-Nr. oder Code',
  'banf.general.shortText': 'Kurztext *',
  'banf.general.shortTextPlaceholder': 'Beschreibung des Artikels',
  'banf.general.quantity': 'Menge *',
  'banf.general.quantityFixed': 'Fest auf 1',
  'banf.general.unitOfMeasure': 'Mengeneinheit',
  'banf.general.unitFixed': 'Fest auf LE',
  'banf.general.deliveryDate': 'Lieferdatum *',
  'banf.general.productGroup': 'Warengruppe *',
  'banf.general.productGroupPlaceholder': 'z.B. IT-Ausstattung',
  'banf.general.plant': 'Werk *',
  'banf.general.searchPlant': 'Suche nach Werk...',
  'banf.general.storageLocation': 'Lagerort',
  'banf.general.storageLocationPlaceholder': 'z.B. 0001',
  'banf.general.priceUnit': 'Preiseinheit',
  'banf.general.priceUnitHint': 'Preis bezieht sich auf diese Menge (z.B. 150,78 € pro 1000). Standard: 1.',
  'banf.general.preferredVendor': 'Wunschlieferant',
  'banf.general.preferredVendorPlaceholder': 'Name des gewünschten Lieferanten',
  'banf.general.estimatedPrice': 'Geschätzter Preis *',
  'banf.general.autoCalculated': 'Automatisch berechnet',
  'banf.general.expectedValueHint': 'Wert aus "Erwarteter Wert" (Limits Tab)',
  'banf.general.plusServicePositions': '+ {count} Leistungsposition',
  'banf.general.plusServicePositionsPlural': '+ {count} Leistungspositionen',
  'banf.general.servicePositions': '{count} Leistungsposition',
  'banf.general.servicePositionsPlural': '{count} Leistungspositionen',
  'banf.general.sumFrom': 'Summe aus ',
  'banf.general.requester': 'Anforderer',
  'banf.general.requesterPlaceholder': 'Name des Anforderers',
  'banf.general.purchasingGroup': 'Einkäufergruppe *',
  'banf.general.searchPurchasingGroup': 'Suche nach Einkäufergruppe...',
  'banf.general.purchasingOrg': 'Einkäuferorganisation',
  'banf.general.searchPurchasingOrg': 'Suche nach Einkäuferorganisation...',
  'banf.general.productCategories.administration': 'Verwaltung',
  'banf.general.productCategories.sales': 'Vertrieb',
  'banf.general.productCategories.production': 'Produktion',
  'banf.general.productCategories.it': 'IT-Ausstattung',
  'banf.general.productCategories.office': 'Büromaterial',
  'banf.general.productCategories.maintenance': 'Wartung & Instandhaltung',
  'banf.general.productCategories.cleaning': 'Reinigung',
  'banf.general.productCategories.security': 'Sicherheit',
  'banf.general.productCategories.automotive': 'Automotive',
  'banf.general.productCategories.electronics': 'Elektronik',
  'banf.general.productCategories.other': 'Sonstiges',

  // ==================== BANF LIMITS TAB ====================
  'banf.limits.totalLimit': 'Gesamtlimit',
  'banf.limits.totalLimitPlaceholder': 'Gesamtlimit eingeben',
  'banf.limits.expectedValue': 'Erwarteter Wert',
  'banf.limits.expectedValueHint': 'Dieser Wert wird im Tab "Allgemein" als Geschätzter Preis verwendet',
  'banf.limits.glAccount': 'Sachkonto',
  'banf.limits.glAccountPlaceholder': 'Sachkonto eingeben',
  'banf.limits.costCenter': 'Kostenstelle',
  'banf.limits.costCenterPlaceholder': 'Kostenstelle eingeben',
  'banf.limits.order': 'Auftrag *',
  'banf.limits.orderPlaceholder': 'Auftragsnummer eingeben (Pflichtfeld)',

  // ==================== BANF SERVICES TAB ====================
  'banf.services.title': 'Leistungen',
  'banf.services.count': 'Leistungen ({count})',
  'banf.services.copyExpanded': 'Aufgeklappte Leistung kopieren',
  'banf.services.copy': 'Kopieren',
  'banf.services.addService': 'Leistung hinzufügen',
  'banf.services.empty': 'Noch keine Leistungen hinzugefügt',
  'banf.services.emptyHint': 'Klicken Sie auf "Leistung hinzufügen" um zu beginnen',
  'banf.services.copySuffix': '(Kopie)',

  // ==================== BANF SERVICE ITEM ====================
  'banf.service.defaultName': 'Leistung {index}',
  'banf.service.remove': 'Leistung entfernen',
  'banf.service.serviceNumber': 'Leistungsnummer',
  'banf.service.serviceNumberPlaceholder': 'Leistungsnummer eingeben',
  'banf.service.shortText': 'Kurztext',
  'banf.service.shortTextPlaceholder': 'Beschreibung der Leistung',
  'banf.service.quantity': 'Menge',
  'banf.service.unitOfMeasure': 'Mengeneinheit',
  'banf.service.grossPrice': 'Bruttopreis',
  'banf.service.currency': 'Währung',
  'banf.service.costCenter': 'Kostenstelle',
  'banf.service.costCenterPlaceholder': 'Kostenstelle eingeben',
  'banf.service.glAccount': 'Sachkonto',
  'banf.service.glAccountPlaceholder': 'Sachkonto eingeben',
  'banf.service.order': 'Auftrag *',
  'banf.service.orderPlaceholder': 'Auftrag eingeben (Pflichtfeld)',

  // ==================== BANF SOURCE TAB ====================
  'banf.source.contract': 'Vertrag',
  'banf.source.contractPlaceholder': 'Vertragsnummer eingeben',
  'banf.source.infoRecord': 'Infosatz',
  'banf.source.infoRecordPlaceholder': 'Infosatz eingeben',
  'banf.source.supplierMatNo': 'Lieferantenmat.-Nr.',
  'banf.source.supplierMatNoPlaceholder': 'Lieferantenmaterialnummer eingeben',
  'banf.source.preferredVendor': 'Wunschlieferant',
  'banf.source.preferredVendorPlaceholder': 'Name des gewünschten Lieferanten',
  'banf.source.fixedVendor': 'Fester Lieferant',
  'banf.source.fixedVendorPlaceholder': 'Fester Lieferant eingeben',
  'banf.source.assignSource': 'Bezugsquelle zuordnen',
  'banf.source.assignTitle': 'Bezugsquelle wählen — aktive Infosätze',
  'banf.source.assignLoading': 'Infosätze werden aus SAP geladen…',
  'banf.source.assignNoMaterial': 'Bitte zuerst ein Material wählen (Tab „Allgemein") — Infosätze hängen am Material.',
  'banf.source.assignEmpty': 'Keine aktiven Infosätze zu diesem Material gefunden.',
  'banf.source.assignUnavailable': 'Die Infosatz-Wertehilfe ist im SAP-Adapter noch nicht verfügbar (Contract §7.4 Punkt 15). Sobald sie bereitsteht, erscheinen hier die aktiven Infosätze automatisch.',

  // ==================== BANF TEXTS TAB ====================
  'banf.texts.headerText': 'Kopftext',
  'banf.texts.headerTextPlaceholder': 'Kopftext für die gesamte Bestellung eingeben...',
  'banf.texts.headerTextHint': 'Allgemeiner Kopftext für die gesamte Bestellung',
  'banf.texts.itemText': 'Positionstext',
  'banf.texts.itemTextPlaceholder': 'Zusätzliche Informationen zur Position eingeben...',
  'banf.texts.itemTextHint': 'Mehrzeiliger Text für zusätzliche Positionsinformationen',

  // ==================== BANF RELEASE STRATEGY ====================
  'banf.release.title': 'Genehmigung',
  'banf.release.strategy': 'Strategie',
  'banf.release.step': 'Stufe {seq}: {code} — {label}',
  'banf.release.pending': 'ausstehend',
  'banf.release.demoNote': 'Die mehrstufige Freigabe erfolgt später über SAP / n8n.',
  'banf.release.threshold': 'Wertgrenze',

  // ==================== BANF ATTACHMENTS TAB ====================
  'banf.attachments.upload': 'Anhänge hochladen',
  'banf.attachments.dropHere': 'Dateien hier ablegen',
  'banf.attachments.dragHere': 'Dateien hier hineinziehen',
  'banf.attachments.selectFiles': 'Dateien auswählen',
  'banf.attachments.maxSize': 'Maximale Dateigröße: 10 MB pro Datei',
  'banf.attachments.tooLarge': '„{name}“ ist größer als 10 MB und wurde nicht übernommen.',
  'banf.attachments.readError': '„{name}“ konnte nicht gelesen werden.',
  'banf.attachments.reading': 'Dateien werden gelesen …',
  'banf.attachments.metaOnly': 'Inhalt nicht gespeichert — bitte neu anhängen',
  'banf.attachments.uploaded': 'Hochgeladene Dateien ({count})',
  'banf.attachments.download': 'Datei herunterladen',
  'banf.attachments.remove': 'Datei entfernen',

  // ==================== PURCHASE REQUESTS VIEW ====================
  'pr.title': 'BANF-Anfragen',
  'pr.statusPending': 'Ausstehend',
  'pr.statusApproved': 'Genehmigt',
  'pr.sapPosted': 'In SAP',
  'pr.sapFailed': 'SAP-Übertragung fehlgeschlagen',
  'pr.sapRetry': 'Erneut übertragen',
  'pr.sapRetryError': 'Erneuter SAP-Übertragungsversuch fehlgeschlagen',
  'pr.statusRejected': 'Abgelehnt',
  'pr.statusTransferred': 'An SAP übertragen',
  'pr.filterAll': 'Alle',
  'pr.filterPending': 'Ausstehend',
  'pr.filterApproved': 'Genehmigt',
  'pr.filterRejected': 'Abgelehnt',
  'pr.filterTransferred': 'Übertragen',
  'pr.drafts': 'Entwürfe',
  'pr.draftFrom': 'Entwurf vom {date}',
  'pr.draftItems': '{count} Positionen',
  'pr.draftResume': 'Fortsetzen',
  'pr.draftDelete': 'Löschen',
  'pr.empty': 'Keine BANF-Anfragen vorhanden',
  'pr.emptyFiltered': 'Keine Anfragen mit diesem Status',
  'pr.approve': 'Genehmigen',
  'pr.reject': 'Ablehnen',
  'pr.transfer': 'An SAP übertragen',
  'pr.detail.requester': 'Anforderer',
  'pr.detail.department': 'Abteilung',
  'pr.detail.costCenter': 'Kostenstelle',
  'pr.detail.date': 'Datum',
  'pr.detail.items': 'Positionen',
  'pr.detail.total': 'Gesamtwert',
  'pr.detail.comment': 'Kommentar',
  'pr.detail.approvedBy': 'Genehmigt von',
  'pr.detail.rejectedBy': 'Abgelehnt von',
  'pr.detail.reason': 'Begründung',
  'pr.commentPlaceholder': 'Kommentar eingeben (optional)...',
  'pr.rejectReasonPlaceholder': 'Begründung für Ablehnung...',
  'pr.loadError': 'Fehler beim Laden der BANF-Anfragen',
  'pr.draftDeleteConfirm': 'Möchten Sie diesen Entwurf wirklich löschen?',
  'pr.draftDeleted': 'Entwurf wurde gelöscht',
  'pr.deleteDraft': 'Entwurf löschen',
  'pr.deleteRequest': 'Löschen',
  'pr.sapTransferFailedShort': 'SAP-Übertragung fehlgeschlagen (Details am SAP-Badge, Retry möglich)',
  'pr.draftDeleteError': 'Fehler beim Löschen des Entwurfs',
  'pr.approveConfirm': 'Sind Sie sicher, dass Sie diese BANF-Anfrage genehmigen möchten?',
  'pr.rejectConfirm': 'Sind Sie sicher, dass Sie diese BANF-Anfrage ablehnen möchten?',
  'pr.requestApproved': 'BANF-Anfrage wurde genehmigt!',
  'pr.requestRejected': 'BANF-Anfrage wurde abgelehnt!',
  'pr.processError': 'Fehler beim Bearbeiten der BANF-Anfrage: {error}',
  'pr.deleteConfirm': 'BANF-Anfrage #{id} von "{name}" löschen? Sie bleibt mit Status „Gelöscht“ in der Übersicht sichtbar (inkl. SAP-Beleg); in SAP erhalten die Positionen das Löschkennzeichen.',
  'pr.requestDeleted': 'BANF-Anfrage #{id} wurde erfolgreich gelöscht!',
  'pr.deleteError': 'Fehler beim Löschen der BANF-Anfrage: {error}',
  'pr.loadingRequests': 'BANF-Anfragen werden geladen...',
  'pr.draftEmptyDesc': 'Wenn Sie die BANF-Ansicht verlassen, werden Ihre Änderungen automatisch als Entwurf gespeichert.',
  'pr.draftDefaultTitle': 'Entwurf #{id}',
  'pr.draftLabel': 'Entwurf',
  'pr.positions': 'Positionen',
  'pr.totalValue': 'Gesamtwert',
  'pr.lastModified': 'Zuletzt geändert',
  'pr.hideDetails': 'Ausblenden',
  'pr.showDetails': 'Details anzeigen',
  'pr.otherCostCenter': 'Andere Kostenstelle',
  'pr.itemArticleNo': 'Artikel-Nr.:',
  'pr.itemMaterialNo': 'Material-Nr.:',
  'pr.itemSupplier': 'Lieferant:',
  'pr.itemUnit': 'Einheit:',
  'pr.itemMatkl': 'Warengruppe:',
  'pr.itemPlant': 'Werk:',
  'pr.itemLgort': 'Lagerort:',
  'pr.itemKontierung': 'Kontierung:',
  'pr.itemKostl': 'Kostenstelle:',
  'pr.itemSakto': 'Sachkonto:',
  'pr.itemAuftrag': 'Auftrag:',
  'pr.itemPsp': 'PSP-Element:',
  'pr.itemDeliveryDate': 'Lieferdatum:',
  'pr.itemEkgrp': 'Einkäufergruppe:',
  'pr.itemPeinh': 'Preiseinheit:',
  'pr.itemFixedVendor': 'Fester Lieferant:',
  'pr.reorder': 'Erneut anlegen',
  'pr.reorderConfirm': 'Positionen der BANF #{id} in eine neue BANF übernehmen? Sie landen im Formular „Neue BANF erstellen" und können dort angepasst werden (Lieferdatum wird neu gesetzt).',
  'pr.commentOptional': 'Kommentar (optional)',
  'pr.editHistory': 'Bearbeitungshistorie',
  'pr.statusHistory': 'Status-Historie',
  'pr.processedAt': 'Bearbeitet am:',
  'pr.statusApprovedFull': '✅ Genehmigt',
  'pr.statusRejectedFull': '❌ Abgelehnt',
  'pr.statusTransferredFull': '📦 An SAP übertragen',
  'pr.statusPendingFull': '⏳ Ausstehend',
  'pr.supervisorComment': 'Kommentar des Vorgesetzten:',

  // --- BANF-Listen-Redesign (bl.*) — Design-Handoff 28.07. ---
  'bl.title': 'BANF-Anfragen',
  'bl.subtitle': 'Bestellanforderungen prüfen, freigeben und nach SAP übertragen.',
  'bl.kpiAwaiting': 'Wartet auf Ihre Freigabe',
  'bl.kpiRequests': 'Anfragen',
  'bl.kpiLeadTime': 'Ø Durchlaufzeit',
  'bl.kpiDays': 'Tage (Anlage → Entscheidung)',
  'bl.kpiNoData': 'noch keine Daten',
  'bl.kpiVolume': 'Volumen gesamt',
  'bl.kpiPosted': 'Nach SAP übertragen',
  'bl.kpiDocs': 'Belege',
  'bl.kpiErrors': 'Fehler',
  'bl.tabAll': 'Alle',
  'bl.tabDrafts': 'Entwürfe',
  'bl.stPending': 'Ausstehend',
  'bl.stApproved': 'Genehmigt',
  'bl.stTransferred': 'Übertragen',
  'bl.stRejected': 'Abgelehnt',
  'bl.stDraft': 'Entwurf',
  'bl.selectAllPending': 'Alle {n} ausstehenden auswählen',
  'bl.searchPlaceholder': 'BANF, Betreff, Lieferant oder SAP-Beleg suchen …',
  'bl.comfortable': 'Komfortabel',
  'bl.compact': 'Kompakt',
  'bl.columns': 'Spalten',
  'bl.export': 'Export',
  'bl.exportError': 'Export fehlgeschlagen',
  'bl.resetFilters': 'Filter zurücksetzen',
  'bl.empty': 'Keine BANF gefunden',
  'bl.colBanf': 'BANF / Betreff',
  'bl.colStatus': 'Status',
  'bl.colAmount': 'Betrag',
  'bl.colDept': 'Abteilung',
  'bl.colAnforderer': 'Anforderer',
  'bl.colKostl': 'Kostenstelle',
  'bl.colMatkl': 'Warengruppe',
  'bl.colLieferant': 'Lieferant',
  'bl.colBelegart': 'Belegart',
  'bl.colErstellt': 'Erstellt',
  'bl.colSap': 'SAP-Beleg',
  'bl.colAction': 'Aktion',
  'bl.waitingApproval': 'wartet auf Freigabe',
  'bl.waiting': 'wartet',
  'bl.draftSub': 'Entwurf · noch nicht eingereicht',
  'bl.position': 'Position',
  'bl.positions': 'Positionen',
  'bl.net': 'netto',
  'bl.approvalPath': 'Genehmigungsweg',
  'bl.stepCreated': 'Angelegt',
  'bl.stepApproval': 'Genehmigung',
  'bl.stepRejected': 'Abgelehnt',
  'bl.stepSap': 'SAP-Übertragung',
  'bl.sapOpen': 'folgt nach der Genehmigung',
  'bl.sapFailed': 'Übertragung fehlgeschlagen',
  'bl.retryStarted': 'SAP-Übertragung erneut gestartet',
  'bl.details': 'Details',
  'bl.edit': 'Bearbeiten',
  'bl.showDetails': 'Details anzeigen',
  'bl.copySap': 'SAP-Beleg kopieren',
  'bl.selected': 'ausgewählt',
  'bl.clearSelection': 'Aufheben',
  'bl.bulkApproveBtn': 'freigeben',
  'bl.bulkNonePending': 'Keine ausstehenden BANFs in der Auswahl — Freigeben/Ablehnen wirkt nur auf ausstehende.',
  'bl.bulkApproveConfirm': '{n} ausstehende BANF-Anfragen freigeben? Jede genehmigte Anfrage wird nach SAP übertragen.',
  'bl.bulkRejectConfirm': '{n} ausstehende BANF-Anfragen ablehnen?',
  'bl.bulkApproved': 'freigegeben',
  'bl.bulkRejected': 'abgelehnt',
  'bl.bulkSkipped': 'übersprungen (nicht ausstehend)',
  'bl.bulkFailed': 'fehlgeschlagen',
  'bl.approvedToast': 'freigegeben',
  'bl.rejectedToast': 'abgelehnt',
  'bl.metaCreated': 'Erstellt',
  'bl.metaDeptKst': 'Abteilung / KST',
  'bl.sapFailedPill': 'SAP-Fehler',
  'bl.stDeleted': 'Gelöscht',
  'bl.loadFailed': 'BANF-Anfragen konnten nicht geladen werden.',
  'bl.retry': 'Erneut versuchen',
  'bl.bulkTooMany': 'Maximal 25 BANFs je Sammelaktion — jede Freigabe löst eine SAP-Buchung aus. Bitte Auswahl verkleinern.',
  'bl.tabSapFailed': 'SAP-Fehler',
};

export default mm;
